import { render } from "./Player.vue?vue&type=template&id=135805fc"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/Player.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "135805fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('135805fc', __exports__)) {
    api.reload('135805fc', __exports__)
  }
  
  module.hot.accept("./Player.vue?vue&type=template&id=135805fc", () => {
    api.rerender('135805fc', render)
  })

}


export default __exports__